module.exports = __webpack_public_path__ + "img/pb.9df3528f.jpg";